/* Retail Fixtures Co — mobile menu, gondola run builder, quote form focus (1-10-2026). */
(function () {
  /* mobile drawer */
  var drawer = document.querySelector('[data-rfc-drawer]'), open = document.querySelector('[data-rfc-open]');
  if (drawer && open) {
    var close = function () { drawer.hidden = true; open.setAttribute('aria-expanded', 'false'); document.documentElement.style.overflow = ''; open.focus(); };
    open.addEventListener('click', function () {
      drawer.hidden = false; open.setAttribute('aria-expanded', 'true'); document.documentElement.style.overflow = 'hidden';
      var b = drawer.querySelector('[data-rfc-close]'); if (b) b.focus();
    });
    drawer.addEventListener('click', function (e) { if (e.target === drawer || e.target.closest('[data-rfc-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
  }

  /* gondola run builder */
  var f = document.querySelector('[data-rfc-gb]');
  var dataEl = document.querySelector('[data-rfc-gb-data]');
  if (f && dataEl) {
    var data = {};
    try { data = JSON.parse(dataEl.textContent); } catch (e) { data = { bays: [] }; }
    var out = f.querySelector('[data-rfc-gb-out]');
    var esc = function (t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; };
    var val = function (n) { var el = f.querySelector('[name="' + n + '"]:checked') || f.querySelector('[name="' + n + '"]'); return el ? el.value : ''; };
    var show = function (scroll) {
      var h = val('rfc-h'), d = val('rfc-d'), lay = val('rfc-l');
      var n = Math.max(1, Math.min(60, parseInt(val('rfc-n'), 10) || 1));
      var ends = parseInt(val('rfc-e'), 10) || 0;
      var html = '';
      if (lay === 'wall') {
        html = '<p class="rfc-gb__msg"><b>Wall run, ' + n + ' bay' + (n > 1 ? 's' : '') + '.</b> Single-sided bays are in our wall shelving range — pick the height and depth there.</p>' +
          '<div class="rfc-gb__links"><a class="is-main" href="' + esc(data.wall) + '">Wall shelving</a>' + (ends ? '<a href="' + esc(data.ends) + '">End bays</a>' : '') + '<a href="' + esc(data.acc) + '">Shelving accessories</a></div>';
      } else {
        var bay = (data.bays || []).filter(function (b) { return String(b.h) === h && String(b.d) === d; })[0];
        if (bay) {
          html = '<a class="rfc-gb__res" href="' + esc(bay.url) + '">' + (bay.img ? '<img src="' + esc(bay.img) + '" alt="" loading="lazy" width="84" height="84">' : '<span></span>') +
            '<span><b>' + esc(bay.title) + '</b><small>Island run: ' + n + ' double-sided bay' + (n > 1 ? 's' : '') + (ends ? ' + ' + ends + ' end bay' + (ends > 1 ? 's' : '') : '') + '. Choose bay width, shelves and colour on the product page.</small></span></a>' +
            '<div class="rfc-gb__links"><a class="is-main" href="' + esc(bay.url) + '">Configure this bay</a>' + (ends ? '<a href="' + esc(data.ends) + '">End bays</a>' : '') + '<a href="' + esc(data.acc) + '">Shelving accessories</a></div>';
        } else {
          html = '<p class="rfc-gb__msg">We don\'t list a ' + esc(h) + ' m bay with a ' + esc(d) + ' mm base yet — <a class="rfc-u" href="#rfc-quote">ask us for a quote</a>.</p>';
        }
      }
      out.innerHTML = html;
      out.hidden = false;
      if (scroll && out.getBoundingClientRect().bottom > window.innerHeight) out.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    };
    var go = f.querySelector('[data-rfc-gb-go]');
    if (go) go.addEventListener('click', function () { show(true); });
    f.addEventListener('change', function () { if (!out.hidden) show(false); });
  }

  /* quote form result into view */
  var ok = document.querySelector('[data-rfc-focus]');
  if (ok) { ok.scrollIntoView({ block: 'center' }); ok.focus({ preventScroll: true }); }
})();

/* collection page: filters, sort, price bands, load more, mobile filter drawer */
(function () {
  var root = document.querySelector('[data-rfc-col]');
  if (!root) return;
  var form = root.querySelector('[data-rfc-filter-form]');
  var submit = function () {
    if (!form) return;
    var url = new URL(form.action, location.href);
    var params = new URLSearchParams();
    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el.name || el.disabled || el.name === 'rfc-price') return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      if (el.value === '' && el.type === 'hidden') return;
      params.append(el.name, el.value);
    });
    location.href = url.pathname + (params.toString() ? '?' + params.toString() : '') + '#rfc-products';
  };
  if (form) {
    form.addEventListener('change', function (e) {
      var r = e.target;
      if (r.name === 'rfc-price') {
        var box = r.closest('[data-rfc-price]');
        box.querySelector('[data-rfc-gte]').value = r.getAttribute('data-gte') || '';
        box.querySelector('[data-rfc-lte]').value = r.getAttribute('data-lte') || '';
      }
      submit();
    });
  }
  var sort = root.querySelector('[data-rfc-sort]');
  if (sort) sort.addEventListener('change', function () {
    var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); u.hash = 'rfc-products'; location.href = u.toString();
  });

  /* load more */
  var more = root.querySelector('[data-rfc-more]'), grid = root.querySelector('[data-rfc-grid]');
  if (more && grid && window.fetch && window.DOMParser) {
    more.addEventListener('click', function (e) {
      e.preventDefault();
      if (more.getAttribute('aria-busy') === 'true') return;
      more.setAttribute('aria-busy', 'true'); var label = more.textContent; more.textContent = 'Loading…';
      fetch(more.href).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('[data-rfc-grid] > li');
        var firstNew = null;
        Array.prototype.forEach.call(items, function (li) { var n = document.importNode(li, true); if (!firstNew) firstNew = n; grid.appendChild(n); });
        var total = parseInt(more.getAttribute('data-total'), 10) || 0, shown = grid.children.length;
        var c = root.querySelector('[data-rfc-count]'); if (c) c.textContent = 'Showing ' + shown + ' of ' + total + ' product' + (total === 1 ? '' : 's');
        var bar = root.querySelector('[data-rfc-bar]'); if (bar && total) bar.style.width = Math.round(shown * 100 / total) + '%';
        var next = doc.querySelector('[data-rfc-more]');
        if (next) { more.href = next.href; more.textContent = next.textContent; more.removeAttribute('aria-busy'); }
        else { more.closest('.rfc-more-wrap').remove(); }
        if (firstNew) { var a = firstNew.querySelector('h3 a'); if (a) a.focus({ preventScroll: true }); }
      }).catch(function () { location.href = more.href; });
    });
  }

  /* mobile filter drawer */
  var filt = root.querySelector('[data-rfc-filt]'), scrim = root.querySelector('[data-rfc-filt-scrim]'), op = root.querySelector('[data-rfc-filt-open]');
  var closeF = function () { filt.classList.remove('is-open'); scrim.hidden = true; document.documentElement.style.overflow = ''; if (op) op.focus(); };
  if (filt && op && scrim) {
    op.addEventListener('click', function () { filt.classList.add('is-open'); scrim.hidden = false; document.documentElement.style.overflow = 'hidden'; var x = filt.querySelector('[data-rfc-filt-close]'); if (x) x.focus(); });
    scrim.addEventListener('click', closeF);
    var x = filt.querySelector('[data-rfc-filt-close]'); if (x) x.addEventListener('click', closeF);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && filt.classList.contains('is-open')) closeF(); });
  }
})();

/* product page: option pills (incl. height × length split), price/VAT, drawings, planner, gallery, qty, buy now, quote prefill */
(function () {
  var root = document.querySelector('[data-rfc-pdp]');
  if (!root) return;
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var product; try { product = JSON.parse($('[data-rfc-product]').textContent); } catch (e) { return; }
  var fmt = root.getAttribute('data-money') || '£{{amount}}';
  var vatMode = 'inc';
  var money = function (c) {
    if (vatMode === 'ex') c = Math.round(c / 1.2);
    var n = (c / 100).toFixed(2).split('.');
    var amt = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + n[1];
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amt).split(' (')[0].split(' Inc')[0].split(' inc')[0];
  };
  var esc = function (t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; };
  var idSel = $('[data-rfc-id]');
  var variants = product.variants || [];
  var current = variants.filter(function (x) { return String(x.id) === idSel.value; })[0] || variants[0];
  var optNames = (product.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
  var hl = {};
  (root.getAttribute('data-hlabels') || '').split(';').forEach(function (p) { var kv = p.split('='); if (kv.length === 2) hl[parseFloat(kv[0])] = kv[1].trim(); });

  var toMM = function (n, u) { n = parseFloat(n); if (u && u.toLowerCase() === 'm' && n < 50) return n * 1000; return n; };
  var pair = function (v) {
    var m = String(v).match(/^\s*([\d.]+)\s*(mm|m)?\s*[x×]\s*([\d.]+)\s*(mm|m)?/i);
    return m ? [toMM(m[1], m[2] || m[4]), toMM(m[3], m[4])] : null;
  };
  var lenOf = function (v) { var m = String(v).match(/([\d.]+)\s*(mm|m)\b/i); return m ? toMM(m[1], m[2]) : null; };
  var fmtM = function (mm) { return (mm >= 1000 || mm % 100 === 0) ? (+(mm / 1000).toFixed(2)) + 'm' : mm + 'mm'; };
  var hoopIcon = function (h, max) { var t = 6 + Math.round(16 * h / max); return '<svg width="30" height="24" viewBox="0 0 30 24" aria-hidden="true"><path d="M7 22V' + (22 - t + 4) + 'q0-4 4-4h8q4 0 4 4V22" fill="none" stroke="currentColor" stroke-width="2.4"/><path d="M3 22h24" stroke="currentColor" stroke-width="1.4"/></svg>'; };

  var opts = optNames.map(function (name, i) {
    var vals = []; variants.forEach(function (x) { if (vals.indexOf(x.options[i]) < 0) vals.push(x.options[i]); });
    var split = vals.length > 1 && vals.every(function (v) { return pair(v); });
    var labels = ['Height', 'Length'];
    var pm = name.match(/\(([^)]+)\)/);
    if (pm && /\sx\s/i.test(pm[1])) labels = pm[1].split(/\s+x\s+/i).map(function (s) { s = s.trim(); return s.charAt(0).toUpperCase() + s.slice(1); });
    return { name: name, i: i, vals: vals, split: split, labels: labels };
  });
  var single = variants.length === 1 && /default/i.test(variants[0].title);
  var sel = current ? current.options.slice() : [];

  var box = $('[data-rfc-opts]');
  var render = function () {
    if (single) { box.innerHTML = ''; return; }
    var html = '', step = 0;
    opts.forEach(function (o) {
      if (o.split) {
        var cur = pair(sel[o.i]) || [];
        var as = [], bs = {}, allB = [];
        o.vals.forEach(function (v) { var p = pair(v); if (as.indexOf(p[0]) < 0) as.push(p[0]); (bs[p[0]] = bs[p[0]] || []).push(p[1]); if (allB.indexOf(p[1]) < 0) allB.push(p[1]); });
        as.sort(function (x, y) { return x - y; }); allB.sort(function (x, y) { return x - y; });
        var maxA = as[as.length - 1];
        var aLabel = o.labels[0] || 'Size';
        if (/^height$/i.test(aLabel) && Object.keys(hl).length) aLabel = 'Height above ground';
        html += '<fieldset class="rfc-og"><legend>' + (++step) + ' · ' + esc(aLabel) + '</legend><div class="rfc-og__p rfc-og__p--3">';
        as.forEach(function (a) {
          var n = bs[a].length, sub = hl[a] || (n + ' ' + (o.labels[1] || 'size').toLowerCase() + (n === 1 ? '' : 's'));
          html += '<button type="button" class="rfc-pill' + (Object.keys(hl).length ? ' rfc-pill--ic' : '') + (a === cur[0] ? ' is-on' : '') + '" aria-pressed="' + (a === cur[0]) + '" data-o="' + o.i + '" data-a="' + a + '">' + (Object.keys(hl).length ? hoopIcon(a, maxA) : '') + '<b>' + a + 'mm</b><small>' + esc(sub) + '</small></button>';
        });
        html += '</div></fieldset><fieldset class="rfc-og"><legend>' + (++step) + ' · ' + esc(o.labels[1] || 'Size') + '</legend><div class="rfc-og__p rfc-og__p--4">';
        allB.forEach(function (b) {
          var ok = (bs[cur[0]] || []).indexOf(b) >= 0;
          html += '<button type="button" class="rfc-pill' + (b === cur[1] ? ' is-on' : '') + (ok ? '' : ' is-na') + '" aria-pressed="' + (b === cur[1]) + '" data-o="' + o.i + '" data-b="' + b + '"' + (ok ? '' : ' aria-disabled="true"') + '><b>' + fmtM(b) + '</b><small>' + b + 'mm</small></button>';
        });
        html += '</div></fieldset>';
      } else {
        html += '<fieldset class="rfc-og"><legend>' + (++step) + ' · ' + esc(o.name) + '</legend><div class="rfc-og__p">';
        o.vals.forEach(function (v) {
          var test = sel.slice(); test[o.i] = v;
          var ok = variants.some(function (x) { return x.options.every(function (y, k) { return y === test[k]; }); });
          html += '<button type="button" class="rfc-pill rfc-pill--txt' + (v === sel[o.i] ? ' is-on' : '') + (ok ? '' : ' is-na') + '" aria-pressed="' + (v === sel[o.i]) + '" data-o="' + o.i + '" data-v="' + esc(v) + '">' + esc(v) + '</button>';
        });
        html += '</div></fieldset>';
      }
    });
    box.innerHTML = html;
  };

  var findV = function () { return variants.filter(function (x) { return x.options.every(function (y, k) { return y === sel[k]; }); })[0]; };
  var add = $('[data-rfc-add]'), now = $('[data-rfc-now]'), price = $('[data-rfc-price]'), selLine = $('[data-rfc-sel]'), qty = $('[data-rfc-qty]');
  var setAddLabel = function () {
    if (!current || !current.available) return;
    add.innerHTML = '<span>Add <span data-rfc-addn>' + (parseInt(qty.value, 10) || 1) + '</span> to basket</span>';
  };
  var showPrice = function () { if (current) price.textContent = money(current.price); var l = $('[data-rfc-vatlbl]'); if (l) l.textContent = vatMode === 'ex' ? 'excl. VAT' : 'incl. VAT'; };
  var update = function (pushUrl) {
    var v = findV();
    if (!v) { add.disabled = true; add.textContent = 'Not available'; if (now) now.hidden = true; return; }
    current = v; idSel.value = v.id;
    showPrice();
    add.disabled = !v.available; if (v.available) setAddLabel(); else add.textContent = 'Sold out';
    if (now) now.hidden = !v.available;
    if (selLine) selLine.innerHTML = (single ? '' : 'Selected: <b>' + esc(v.title) + '</b>') + (v.sku ? (single ? '' : ' · ') + 'SKU ' + esc(v.sku) : '');
    var ss = $('[data-rfc-spec-sel]'); if (ss) ss.textContent = v.title;
    var sk = $('[data-rfc-spec-sku]'); if (sk) sk.textContent = v.sku || '—';
    var po = $('[data-rfc-pq-opt]'); if (po) po.value = v.title;
    if (pushUrl) { try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {} }
    if (v.featured_media && !drawOn) showSlide('m' + v.featured_media.id);
    draw(); plan(); prefill();
  };
  box.addEventListener('click', function (e) {
    var b = e.target.closest('.rfc-pill'); if (!b || b.getAttribute('aria-disabled') === 'true') return;
    var i = +b.getAttribute('data-o'), o = opts[i];
    if (b.hasAttribute('data-v')) sel[i] = b.getAttribute('data-v');
    else {
      var cur = pair(sel[i]) || [], a = cur[0], bb = cur[1];
      if (b.hasAttribute('data-a')) a = +b.getAttribute('data-a'); else bb = +b.getAttribute('data-b');
      var exact = o.vals.filter(function (v) { var p = pair(v); return p[0] === a && p[1] === bb; })[0];
      if (!exact) exact = o.vals.filter(function (v) { var p = pair(v); return p[0] === a; })[0];
      sel[i] = exact;
    }
    if (!findV()) { var fb = variants.filter(function (x) { return x.options[i] === sel[i]; })[0]; if (fb) sel = fb.options.slice(); }
    render(); update(true);
  });

  /* VAT switch */
  $$('[data-rfc-vat]').forEach(function (b, _, all) {
    b.addEventListener('click', function () {
      vatMode = b.getAttribute('data-rfc-vat');
      all.forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      showPrice();
    });
  });

  /* gallery */
  var slides = $$('.rfc-pgal__s'), thumbs = $$('[data-show]'), drawOn = false;
  var showSlide = function (k) {
    if (!slides.some(function (s) { return s.getAttribute('data-slide') === k; })) return;
    slides.forEach(function (s) { s.classList.toggle('is-on', s.getAttribute('data-slide') === k); });
    thumbs.forEach(function (t) { var on = t.getAttribute('data-show') === k; t.classList.toggle('is-on', on); t.setAttribute('aria-pressed', on ? 'true' : 'false'); });
  };
  thumbs.forEach(function (t) { t.addEventListener('click', function () { showSlide(t.getAttribute('data-show')); }); });

  /* drawings (hoop barriers) */
  var dims = function () { var o = opts.filter(function (x) { return x.split; })[0]; return o ? pair(sel[o.i]) : null; };
  var hoopPath = function (cx, w, h, g, r) {
    var x0 = cx - w / 2, x1 = cx + w / 2, top = g - h; r = Math.min(r, w / 3, h / 2);
    return 'M' + x0 + ' ' + g + 'V' + (top + r) + 'Q' + x0 + ' ' + top + ' ' + (x0 + r) + ' ' + top + 'H' + (x1 - r) + 'Q' + x1 + ' ' + top + ' ' + x1 + ' ' + (top + r) + 'V' + g;
  };
  var svg = $('[data-rfc-draw]'), ctx = $('[data-rfc-ctx]');
  var draw = function () {
    if (!svg) return;
    var d = dims();
    var slide = $('[data-rfc-draw-slide]'), btn = $('[data-rfc-draw-btn]'), cs = $('[data-rfc-ctx-slide]'), cb = $('[data-rfc-ctx-btn]');
    if (!d) { [slide, cs].forEach(function (x) { if (x) { x.hidden = true; x.classList.remove('is-on'); } }); [btn, cb].forEach(function (x) { if (x) x.hidden = true; }); return; }
    if (slide && slide.hidden) { slide.hidden = false; btn.hidden = false; if (cs) { cs.hidden = false; cb.hidden = false; } drawOn = true; showSlide('draw'); }
    var sc = 0.14, H = d[0], L = d[1], g = 214;
    var w = L * sc, h = H * sc, x0 = 200 - w / 2, x1 = 200 + w / 2, top = g - h, r = 22;
    svg.querySelector('[data-rfc-hoop]').setAttribute('d', hoopPath(200, w, h, g, r));
    svg.querySelector('[data-rfc-hoop-hl]').setAttribute('d', 'M' + (x0 - 2) + ' ' + (g - 4) + 'V' + (top + Math.min(r, w / 3, h / 2)));
    svg.querySelector('[data-rfc-plates]').innerHTML = '<rect x="' + (x0 - 12) + '" y="' + (g - 4) + '" width="24" height="5" rx="1"/><rect x="' + (x1 - 12) + '" y="' + (g - 4) + '" width="24" height="5" rx="1"/>';
    svg.querySelector('[data-rfc-tube]').setAttribute('y', Math.max(14, top - 14));
    var hd = svg.querySelector('[data-rfc-hdim]'), hx = x0 - 26;
    hd.querySelector('path').setAttribute('d', 'M' + hx + ' ' + top + 'V' + g + 'M' + (hx - 6) + ' ' + top + 'H' + (hx + 6) + 'M' + (hx - 6) + ' ' + g + 'H' + (hx + 6));
    var ht = 'H ' + H + 'mm', hw = ht.length * 7 + 14;
    hd.querySelector('rect').setAttribute('x', hx - hw - 4); hd.querySelector('rect').setAttribute('y', top + h / 2 - 10); hd.querySelector('rect').setAttribute('width', hw);
    var t1 = hd.querySelector('text'); t1.setAttribute('x', hx - hw / 2 - 4); t1.setAttribute('y', top + h / 2 + 4); t1.textContent = ht;
    var ld = svg.querySelector('[data-rfc-ldim]'), ly = g + 22;
    ld.querySelector('path').setAttribute('d', 'M' + x0 + ' ' + ly + 'H' + x1 + 'M' + x0 + ' ' + (ly - 6) + 'V' + (ly + 6) + 'M' + x1 + ' ' + (ly - 6) + 'V' + (ly + 6));
    var lt = 'L ' + L + 'mm', lw = lt.length * 7 + 14;
    ld.querySelector('rect').setAttribute('x', 200 - lw / 2); ld.querySelector('rect').setAttribute('y', ly + 6); ld.querySelector('rect').setAttribute('width', lw);
    var t2 = ld.querySelector('text'); t2.setAttribute('x', 200); t2.setAttribute('y', ly + 20); t2.textContent = lt;
    if (ctx) {
      var s2 = 0.1, ph = 1750 * s2, px = 110;
      var hy = g - ph, bw = 26;
      ctx.querySelector('[data-rfc-person]').innerHTML = '<circle cx="' + px + '" cy="' + (hy + 11) + '" r="11"/><rect x="' + (px - bw / 2) + '" y="' + (hy + 25) + '" width="' + bw + '" height="' + (ph * 0.42) + '" rx="8"/><rect x="' + (px - bw / 2) + '" y="' + (hy + 25 + ph * 0.38) + '" width="11" height="' + (g - (hy + 25 + ph * 0.38)) + '" rx="4"/><rect x="' + (px + bw / 2 - 11) + '" y="' + (hy + 25 + ph * 0.38) + '" width="11" height="' + (g - (hy + 25 + ph * 0.38)) + '" rx="4"/>';
      ctx.querySelector('[data-rfc-hoop2]').setAttribute('d', hoopPath(250, L * s2, H * s2, g, 12));
      ctx.querySelector('[data-rfc-ctxt]').textContent = H + 'mm hoop next to a 1.75m person';
    }
  };

  /* how many do I need */
  var planBox = $('[data-rfc-plan]'), run = $('[data-rfc-run]'), gap = $('[data-rfc-gap]');
  var unitLen = function () {
    var d = dims(); if (d) return d[1];
    for (var i = 0; i < opts.length; i++) { if (/length|width/i.test(opts[i].name)) { var l = lenOf(sel[i]); if (l) return l; } }
    return null;
  };
  var need = 0;
  var plan = function () {
    if (!planBox) return;
    var l = unitLen();
    if (!l) { planBox.hidden = true; return; }
    planBox.hidden = false;
    var r = parseFloat(run.value), gp = Math.max(0, parseFloat(gap.value) || 0);
    var out = $('[data-rfc-plan-out]'), vis = $('[data-rfc-vis]');
    if (!(r > 0)) { out.textContent = ''; vis.innerHTML = ''; return; }
    need = Math.max(1, Math.ceil((r * 1000 + gp) / (l + gp) - 1e-9));
    var cover = (need * l + (need - 1) * gp) / 1000;
    $('[data-rfc-need]').textContent = need;
    out.textContent = need + ' × ' + fmtM(l) + (gp ? ' with ' + gp + 'mm gaps' : ' end to end') + ' covers ' + (+cover.toFixed(2)) + 'm. Estimate only — check on site.';
    var k = Math.min(need, 24), g = '';
    for (var j = 0; j < k; j++) g += '<i' + (gp ? ' class="has-gap"' : '') + '></i>';
    vis.innerHTML = g + (need > k ? '<b>+' + (need - k) + '</b>' : '');
  };
  [run, gap].forEach(function (x) { if (x) x.addEventListener('input', function () { plan(); prefill(); }); });
  var use = $('[data-rfc-use]'); if (use) use.addEventListener('click', function () { if (need > 0) { qty.value = need; setAddLabel(); prefill(); qty.focus(); } });

  /* project quote prefill */
  var msg = $('[data-rfc-pq-msg]'), pre = $('[data-rfc-pre]'), edited = false;
  if (msg) msg.addEventListener('input', function () { edited = true; });
  var prefill = function () {
    if (!current) return;
    var q = parseInt(qty.value, 10) || 1;
    var bits = (single ? '' : current.title + ' · ') + q + ' unit' + (q === 1 ? '' : 's');
    if (planBox && !planBox.hidden && run && parseFloat(run.value) > 0) bits += ' for ' + run.value + 'm';
    if (pre) { pre.hidden = false; $('[data-rfc-pre-v]').textContent = bits; }
    if (msg && !edited) msg.value = product.title + '\n' + bits + '\n';
  };

  /* qty + buy now + print */
  $$('[data-rfc-step]').forEach(function (b) { b.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-rfc-step'), 10)); setAddLabel(); prefill(); }); });
  qty.addEventListener('input', function () { setAddLabel(); prefill(); });
  var ret = $('[data-rfc-return]');
  if (now && ret) { now.addEventListener('click', function () { ret.disabled = false; }); add.addEventListener('click', function () { ret.disabled = true; }); }
  var pr = $('[data-rfc-print]'); if (pr) pr.addEventListener('click', function () { window.print(); });

  /* boot */
  var fb = $('[data-rfc-fallback]'); if (fb) fb.hidden = true;
  render(); update(false);
  if (!drawOn && slides.length && !slides.some(function (s) { return s.classList.contains('is-on') && !s.hidden; })) {
    var firstPhoto = slides.filter(function (s) { return !s.hidden; })[0]; if (firstPhoto) showSlide(firstPhoto.getAttribute('data-slide'));
  }
})();

/* cart page: qty auto-update, save for later, VAT switch, references, discount code, share link, print, project quote, recommendations */
(function () {
  var root = document.querySelector('[data-rfc-cart]');
  if (!root) return;
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var fmt = root.getAttribute('data-money') || '£{{amount}}';
  var money = function (c) {
    var n = (c / 100).toFixed(2).split('.');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + n[1]).split(' (')[0].split(' Inc')[0].split(' inc')[0];
  };
  var esc = function (t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; };
  var post = function (url, body) { return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }).then(function (r) { if (!r.ok) throw r; return r.json(); }); };
  var reload = function () { location.reload(); };

  /* quantity: debounce then /cart/change.js */
  var timers = {};
  $$('.rfc-line').forEach(function (li) {
    var line = +li.getAttribute('data-line'), input = $('[data-rfc-cqty]', li);
    var push = function () {
      clearTimeout(timers[line]);
      timers[line] = setTimeout(function () { li.classList.add('is-busy'); post('/cart/change.js', { line: line, quantity: Math.max(0, parseInt(input.value, 10) || 0) }).then(reload).catch(reload); }, 500);
    };
    $$('[data-rfc-cstep]', li).forEach(function (b) { b.addEventListener('click', function () { input.value = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-rfc-cstep'), 10)); push(); }); });
    input.addEventListener('change', push);
    var save = $('[data-rfc-save]', li);
    if (save) save.addEventListener('click', function () {
      var item = { id: li.getAttribute('data-variant'), title: li.getAttribute('data-title'), v: li.getAttribute('data-vtitle'), url: li.getAttribute('data-url'), img: li.getAttribute('data-img'), price: +li.getAttribute('data-price'), qty: parseInt(input.value, 10) || 1 };
      try { var list = JSON.parse(localStorage.getItem('rfc-saved') || '[]').filter(function (x) { return x.id !== item.id; }); list.unshift(item); localStorage.setItem('rfc-saved', JSON.stringify(list.slice(0, 20))); } catch (e) {}
      li.classList.add('is-busy');
      post('/cart/change.js', { line: line, quantity: 0 }).then(reload).catch(reload);
    });
  });

  /* saved for later list */
  var savedBox = $('[data-rfc-saved]');
  var renderSaved = function () {
    if (!savedBox) return;
    var list = []; try { list = JSON.parse(localStorage.getItem('rfc-saved') || '[]'); } catch (e) {}
    if (!list.length) { savedBox.hidden = true; return; }
    savedBox.hidden = false;
    $('[data-rfc-saved-list]', savedBox).innerHTML = list.map(function (x, i) {
      return '<li><a class="rfc-saved__img" href="' + esc(x.url) + '">' + (x.img ? '<img src="' + esc(x.img) + '" alt="" loading="lazy" width="64" height="64">' : '') + '</a><div><a href="' + esc(x.url) + '"><b>' + esc(x.title) + '</b></a>' + (x.v ? '<small>' + esc(x.v) + '</small>' : '') + '</div><button type="button" class="rfc-btn rfc-btn--dark rfc-btn--sm" data-move="' + i + '">Move to basket</button><button type="button" class="rfc-link" data-drop="' + i + '">Remove</button></li>';
    }).join('');
  };
  if (savedBox) savedBox.addEventListener('click', function (e) {
    var mv = e.target.closest('[data-move]'), dr = e.target.closest('[data-drop]');
    if (!mv && !dr) return;
    var list = []; try { list = JSON.parse(localStorage.getItem('rfc-saved') || '[]'); } catch (er) {}
    var i = +(mv || dr).getAttribute(mv ? 'data-move' : 'data-drop'), it = list[i];
    list.splice(i, 1); try { localStorage.setItem('rfc-saved', JSON.stringify(list)); } catch (er) {}
    if (mv && it) post('/cart/add.js', { items: [{ id: +it.id, quantity: it.qty || 1 }] }).then(reload).catch(function () { location.href = it.url; });
    else renderSaved();
  });
  renderSaved();

  /* VAT switch on line prices */
  $$('[data-rfc-cvat]').forEach(function (b, _, all) {
    b.addEventListener('click', function () {
      var ex = b.getAttribute('data-rfc-cvat') === 'ex';
      all.forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      $$('[data-rfc-money]').forEach(function (el) { var c = +el.getAttribute('data-rfc-money'); el.textContent = money(ex ? Math.round(c / 1.2) : c) + (ex ? ' ex VAT' : ''); });
    });
  });

  /* references → cart attributes / note (saved as you type) */
  var refT;
  $$('[data-rfc-attr]').forEach(function (el) {
    el.addEventListener('input', function () {
      clearTimeout(refT);
      refT = setTimeout(function () {
        post('/cart/update.js', { note: ($('#rfc-note') || {}).value || '', attributes: { 'PO number': ($('#rfc-po') || {}).value || '', 'Site name': ($('#rfc-site') || {}).value || '' } }).catch(function () {});
      }, 600);
    });
  });

  /* discount code */
  var code = $('[data-rfc-code]'), apply = $('[data-rfc-apply]');
  var go = function () { var c = (code.value || '').trim(); if (c) location.href = '/discount/' + encodeURIComponent(c) + '?redirect=' + encodeURIComponent('/cart'); };
  if (apply) apply.addEventListener('click', go);
  if (code) code.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); go(); } });

  /* share basket link (cart permalink) */
  var share = $('[data-rfc-share]');
  if (share) share.addEventListener('click', function () {
    var parts = $$('.rfc-line').map(function (li) { return li.getAttribute('data-variant') + ':' + (parseInt($('[data-rfc-cqty]', li).value, 10) || 1); });
    var url = location.origin + '/cart/' + parts.join(',') + '?storefront=true';
    var msg = $('[data-rfc-share-msg]');
    var done = function () { if (msg) msg.textContent = 'Link copied — paste it to a colleague'; };
    if (navigator.share) { navigator.share({ title: 'Basket', url: url }).catch(function () {}); }
    else if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copy this link', url); });
    else window.prompt('Copy this link', url);
  });

  /* print as PDF quote */
  var pr = $('[data-rfc-print-cart]'); if (pr) pr.addEventListener('click', function () { document.documentElement.classList.add('rfc-printing'); window.print(); setTimeout(function () { document.documentElement.classList.remove('rfc-printing'); }, 500); });

  /* project quote panel */
  var po = $('[data-rfc-proj-open]'), pb = $('[data-rfc-proj]');
  if (po && pb) po.addEventListener('click', function () { pb.hidden = false; po.setAttribute('aria-expanded', 'true'); pb.scrollIntoView({ behavior: 'smooth', block: 'start' }); var f = pb.querySelector('input:not([type=hidden])'); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 400); });
  if (pb && pb.querySelector('.rfc-ok, .rfc-err')) pb.hidden = false;

  /* complete the job: related products for the first basket items */
  var cx = $('[data-rfc-cx]');
  if (cx && window.fetch) {
    var ids = (cx.getAttribute('data-ids') || '').split(',').filter(Boolean);
    var inCart = ids.map(Number), seen = {};
    Promise.all(ids.slice(0, 3).map(function (id) {
      return fetch('/recommendations/products.json?product_id=' + id + '&limit=6&intent=related').then(function (r) { return r.ok ? r.json() : { products: [] }; }).catch(function () { return { products: [] }; });
    })).then(function (res) {
      var out = [];
      res.forEach(function (r) { (r.products || []).forEach(function (p) { if (inCart.indexOf(p.id) < 0 && !seen[p.id] && out.length < 3) { seen[p.id] = 1; out.push(p); } }); });
      if (!out.length) return;
      $('[data-rfc-cx-list]', cx).innerHTML = out.map(function (p) {
        var single = p.variants && p.variants.length === 1;
        var img = p.featured_image ? (typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.src) : '';
        if (img) img = img + (img.indexOf('?') < 0 ? '?' : '&') + 'width=200';
        return '<li class="rfc-cxc"><a class="rfc-cxc__img" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="96" height="96">' : '') + '</a><div>' + (p.type ? '<p class="rfc-cxc__k">' + esc(p.type) + '</p>' : '') + '<h3><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3><div class="rfc-cxc__ft"><b>' + (p.price_varies ? 'From ' : '') + money(p.price) + '</b>' + (single && p.available ? '<button type="button" class="rfc-btn rfc-btn--dark rfc-btn--sm" data-cx-add="' + p.variants[0].id + '">Add</button>' : '<a class="rfc-btn rfc-btn--line rfc-btn--sm" href="' + esc(p.url) + '">Choose options</a>') + '</div></div></li>';
      }).join('');
      cx.hidden = false;
    });
    cx.addEventListener('click', function (e) { var b = e.target.closest('[data-cx-add]'); if (!b) return; b.disabled = true; post('/cart/add.js', { items: [{ id: +b.getAttribute('data-cx-add'), quantity: 1 }] }).then(reload).catch(reload); });
  }

  /* quote result into view */
  var ok = root.querySelector('[data-rfc-focus]'); if (ok) { ok.scrollIntoView({ block: 'center' }); ok.focus({ preventScroll: true }); }
})();
